module.exports = __webpack_public_path__ + "static/stairs2-8d3e312bb97b1ed2f92c2613901b1a33.jpg";